import {
  SET_SEARCH_KIND,
  SET_SEARCH_QUERY,
  CLEAR_QUERIES,
} from './mutation-types'

const defaultCompanyView = {
  columns: [
    {
      label: 'Base Country',
      name: 'baseCountry',
    },
    {
      label: 'Sector',
      name: 'sector',
      sortable: true,
    },
  ],
  sorting: {
    key: 'displayName',
    order: 'asc',
  },
}

const defaultPersonView = {
  columns: [],
  sorting: {
    key: 'displayName',
    order: 'asc',
  },
}

const defaultSigdevView = {
  columns: [],
  sorting: {
    key: 'displayName',
    order: 'asc',
  },
}

const state = {
  kind: 'company',
  query: '',
  clearQueries: 0,
  initResultview: { ...defaultCompanyView },
}

const mutations = {
  [SET_SEARCH_KIND](state, payload) {
    state.kind = payload
    const initViews = {
      person: defaultPersonView,
      company: defaultCompanyView,
      sigdev: defaultSigdevView,
    }
    state.initResultview = { ...initViews[payload] }
  },
  [SET_SEARCH_QUERY](state, payload) {
    state.query = payload
  },
  [CLEAR_QUERIES](state) {
    state.clearQueries += 1
  },
}

const actions = {
  setSearchKind({ commit, dispatch }, payload) {
    commit(SET_SEARCH_KIND, payload)
    dispatch('getFacets')
  },
  setSearchQuery({ commit }, payload) {
    commit(SET_SEARCH_QUERY, payload)
  },
  clearQueries({ commit }) {
    commit(CLEAR_QUERIES)
  },
}

const getters = {
  searchKind: state => state.kind,
  searchQuery: state => state.query,
  clearQueries: state => state.clearQueries,
  initResultview: state => state.initResultview,
  isPersonSearchPage: (state, getters, routeState) =>
    routeState.route.path.includes('search/people'),
}

export default {
  state,
  mutations,
  actions,
  getters,
}
